import actionTypes from "../actions/actionTypes";
import * as storage from "../coraWebComponents/utils/storage";

const user = (
  state = {
    isLoading: false,
    data: storage.getUser(),
  },
  action
) => {
  switch (action.type) {
    case actionTypes.LOGIN_REQUEST:
    case actionTypes.LOGIN_OAUTH_REQUEST:
    case actionTypes.CREATE_USER_REQUEST:
    case actionTypes.REFRESH_USER_REQUEST:
    case actionTypes.CREATE_ORGAN_REQUEST:
    case actionTypes.UPDATE_USER_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.REFRESH_USER_SUCCESS:
      return { isLoading: false, data: storage.getUser() };

    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.LOGIN_OAUTH_SUCCESS:
      return { isLoading: false, data: action.res.Data };

    case actionTypes.CREATE_ORGAN_SUCCESS:
    case actionTypes.CREATE_ORGAN_FAILURE:
    case actionTypes.CREATE_USER_SUCCESS:
    case actionTypes.CREATE_USER_FAILURE:
    case actionTypes.UPDATE_USER_SUCCESS:
    case actionTypes.UPDATE_USER_FAILURE:
      return { ...state, isLoading: false };

    case actionTypes.REFRESH_USER_FAILURE:
    case actionTypes.LOGIN_FAILURE:
    case actionTypes.LOGIN_OAUTH_FAILURE:
      return { isLoading: false, data: null };

    case actionTypes.SIGN_OUT:
      storage.removeUser();
      return { isLoading: false, data: null };

    default:
      return state;
  }
};

export default user;
